import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {}

export default handleActions({
    [type.INIT_GLOBALS]: (state, action) => {
        const { globals } = action.payload
        return {
            ...globals,
        }
    },
    [type.SAVE_VIEW_PREFERENCES]: (state, action) => {
        const viewPreferences = action.payload
        return {
            ...state,
            user: {
                ...state.user,
                viewPreferences,
            },
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/globals/state/reducer.js